<template>
    <div class="look_context">
        <div class="header">
            <div class="title">{{viewTitle}}</div>
        </div>
        <div class="btn_box">
            <el-button size="mini"
                       v-if="this.form.is_quit == 1"
                       @click="editRow('user')">编辑人员</el-button>
            <el-button size="mini"
                       @click="editRow('change')">更换人员</el-button>
            <el-button size="mini"
                       v-if="this.form.is_quit == 1"
                       class="table_del_btn" @click="leaveOffice">
                离职
            </el-button>
            <el-button size="mini"
                       class="table_del_btn"
                       @click="delRowUser">
                删除人员
            </el-button>
            <el-button size="mini"
                       type="primary"
                       v-if="form.is_lock == 2"
                       @click="openLockedDialog('is_lock')">
                解除锁定
            </el-button>
            <el-button size="mini"
                       type="primary"
                       v-if="form.patient_is_lock == 2"
                       @click="openLockedDialog('patient_is_lock')">
                解除附件锁定
            </el-button>
            <el-button size="mini"
                       class="table_del_btn"
                       @click="refreshCheckCode">
                重置核验码
            </el-button>
        </div>
        <div class="main_box">
            <el-form :model="form" size="small" label-width="140px">
                <el-form-item label="姓名：">
                    <div>
                        <span>{{form.name}}</span>
                        <span v-if="form.is_quit == 2">（离职）</span>
                    </div>
                </el-form-item>
                <el-form-item label="工号：">
                    <div>{{form.job_number}}</div>
                </el-form-item>
                <el-form-item label="手机号：">
                    <div>{{form.phone}}</div>
                </el-form-item>
                <div class="job_box"
                     v-for="(item, index) in form.job_list"
                     :key="index">
                    <div class="item_btn_box">
                        <div class="left_index">{{index + 1}}.</div>
                        <div class="right_btn">
                            <el-button size="mini"
                                       @click="editRow('work', item)">编辑岗位
                            </el-button>
                            <el-button size="mini"
                                       class="table_del_btn"
                                       @click="delRow(item)">删除岗位
                            </el-button>
                        </div>
                    </div>
                    <el-form-item label="部门：">
                        <div class="a_text" @click="goToNode(item)">{{item.department_name}}</div>
                    </el-form-item>
                    <el-form-item label="岗位：">
                        <div>{{item.job}}</div>
                    </el-form-item>
                    <el-form-item label="职位：">
                        <div v-text="showIfList(item.is_manager)"></div>
                    </el-form-item>
                    <el-form-item label="管理医院：">
                        <div class="table">
                            <el-table :data="item.hospital_list" stripe width="100%">
                                <el-table-column type="index" label="序号" width="60"></el-table-column>
                                <el-table-column v-for="(items, indexs) in columnData"
                                                 :prop="items.prop"
                                                 :label="items.label"
                                                 :width="items.width"
                                                 :formatter="items.formatter"
                                                 :fixed="items.fixed"
                                                 show-overflow-tooltip
                                                 :key="indexs"></el-table-column>
                            </el-table>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <el-dialog :title="locked_dailog_title"
                   width="450px"
                   :modal="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="locked_dialog">
            <div class="msg__">
                <span>将解除</span>
                <span class="table_del_btn" style="padding-left: 5px">{{form.name}}</span>
                <span>核验码锁定</span>
            </div>
            <div class="msg__" v-if="locked_type === 'is_lock'">
                <el-checkbox v-model="locked_is_refresh">
                    <span class="msg_c">同时重置核验码</span>
                </el-checkbox>
            </div>


            <span slot="footer" class="dialog-footer">
                <el-button @click="locked_dialog = false">取 消</el-button>
                <el-button type="primary" @click="clearLocked">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "edit",
        data() {
            const showHos = (row, column, cellValue, index) => {
                // return  `${row.province}/${row.city}/${row.region}`
                return `${row.province}/${row.city}`
            };
            const showDrug = (row, column, cellValue, index) => {
                let text = '';
                this.drug_code_list.forEach(v => {
                    if (v.drug_code == cellValue) {
                        text = v.name
                    }
                });
                return text
            };
            return {
                viewTitle: '成员详情',
                form: {},
                ifList: [
                    {name: '代表', value: 1},
                    {name: '经理', value: 2},
                    {name: 'RPM', value: 3},
                    {name: 'RPMHead', value: 4},
                ],

                tableData: [],
                columnData: [
                    {label: '医院名称', prop: 'name'},
                    {label: '医院地区', prop: 'region', formatter: showHos},
                    {label: '详细地址', prop: 'address'},
                    {label: '产品', prop: 'drug_code', formatter: showDrug},
                ],

                locked_dialog: false,
                locked_dailog_title: '解除用户锁定',
                locked_row: {},
                locked_is_refresh: false
            }
        },
        computed: {
            ...mapState('manageData', {
                searchStaff: 'searchStaff',
                showTree: 'showTree'
            }),
            ...mapState('comInformationData', [
                'drug_code_list'
            ])
        },
        watch: {
            searchStaff() {
                this.getLook()
            }
        },
        mounted() {
            if (this.searchStaff.user_id) {
                this.getLook()
            }
        },
        methods: {
            ...mapMutations('manageData', {
                setStaffData: 'setStaffData',
                setStaffTreeNode: 'setStaffTreeNode',
                setShowTree: 'setShowTree'
            }),
            showIfList(id) {
                let text = '';
                this.ifList.map(v => {
                    if (id == v.value) {
                        text = v.name
                    }
                });
                return text
            },
            openLockedDialog(type) {
                this.locked_dialog = true;
                this.locked_is_refresh = false;
                this.locked_type = type
                this.locked_dailog_title = type === 'patient_is_lock' ? '解除附件锁定' : '解除用户锁定';
            },
            clearLocked() {
                let params = {
                    user_id: this.form.user_id,
                    is_reset: this.locked_is_refresh?2:1,
                };
                if(this.locked_type === 'patient_is_lock') {
                    params.is_patient = 1
                }
                this.httpGet('/user/rep/unlock', params).then(res => {
                    this.$message.success(`${this.locked_dailog_title}成功！`);
                    if(this.locked_type === 'patient_is_lock') {
                        this.form.patient_is_lock = 1;
                    } else {
                        this.form.is_lock = 1;
                    }
                    this.locked_dialog = false;
                })
            },
            refreshCheckCode() {
                let params = {
                    user_id: this.form.user_id
                };
                this.httpGet('/user/validate_password/reset', params).then(res => {
                    this.$message.success('核验码重置成功！');
                })
            },

            delRow(item) {
                this.$confirm(`确定删除岗位 ${item.job} 么？`).then(() => {
                    let params = {
                        department_id: item.department_id,
                        job: item.job
                    };
                    this.httpDel(`/user/rep_job`, {params}).then(res => {
                        this.$message.success('删除成功！');
                        this.getLook()
                    })
                }).catch(() => {
                })
            },
            delRowUser() {
                let row = this.form;
                this.$confirm(`确定删除员工 ${row.name} 么？`).then(() => {
                    this.httpDel(`/user/rep/${row.user_id}`).then(res => {
                        this.$message.success('删除成功！');
                        // this.getLook()
                    })
                }).catch(err => {
                    if (err.code === 1002) {
                        this.$message.warning('该用户有关联患者，无法删除')
                    }
                })
            },
            leaveOffice() {
                let row = this.form;
                this.$confirm(`确定员工 ${row.name} 已离职么？`).then(() => {
                    let params = {
                        user_id: row.user_id
                    };
                    this.httpPost(`/user/rep/leave_office`, params).then(res => {
                        this.$message.success('离职成功！');
                        // this.getLook()
                    })
                })
            },

            editRow(type, item) {
                // this.$message.warning('正在开发中');
                let row = {};
                let com = {
                    job: "",
                    department_id: '',
                };
                if (item) {
                    row = {
                        ...this.form,
                        ...item,
                    }
                } else {
                    let aa = this.form.job_list.length > 0 ? this.form.job_list[0] : com;
                    row = {
                        ...this.form,
                        ...aa
                    }
                }
                let params = {
                    row: row,
                    type: type
                };
                this.setStaffData(params);
                this.$emit('changeTopTab', 'addView');
            },
            getLook() {
                this.httpGet(`/user/rep_detail/${this.searchStaff.user_id}`).then(res => {
                    this.form = res.data;
                    if (this.form.job_list && this.form.job_list.length > 0) {
                        this.getSelectHospital()
                    }
                })
            },

            getSelectHospital() {
                const that = this;
                const get_n_2 = function get_n_2(job) {
                    return new Promise((resolve, reject) => {
                        let params = {
                            job: job
                        };
                        that.httpGet('/hospital/job_hospital', params).then(res => {
                            resolve(res.data)
                        })
                    })
                };
                let hos = [];
                this.form.job_list.forEach(v => {
                    hos.push(get_n_2(v.job))
                });
                Promise.all(hos).then(res => {
                    this.form.job_list.forEach((v, i) => {
                        v.hospital_list = res[i]
                    });
                    this.$forceUpdate()
                })
            },

            goToNode(item) {

                let name = item.department_name.split('>');
                let data = {
                    department_id: item.department_id,
                    // level: 3,
                    name: name[name.length - 1],
                    // parent_id: 2,
                };
                console.log(this.form, data, '176');
                this.setStaffTreeNode(data);
                this.setShowTree(true);
                this.$emit('changeShowTree');
                this.$emit('changeTopTab', 'tableView')
            },
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .look_context {
        width: 100%;
        height: 100%;
        background: $view_background;
        display: flex;
        flex-flow: column;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            .title {

            }
        }
        .btn_box {
            padding: 5px 10px;
            background: #DBE6F3;
        }
        .main_box {
            padding: 10px;
            flex: 1;
            overflow: hidden;
            overflow-y: auto;

            .job_box {
                border: 1px solid #fff;
                border-radius: 2px;
                box-sizing: border-box;
                .item_btn_box {
                    display: flex;
                    height: 40px;
                    align-items: center;
                    background-color: #fff;
                    .left_index {
                        font-size: 20px;
                        font-weight: 600;
                        padding-left: 60px;
                        padding-right: 10px;
                    }
                    .right_btn {
                        flex: 1;
                    }
                }
                .a_text {
                    color: #409EFF;
                    cursor: pointer;
                }
            }
        }
    }

    .table {
        /*width: 600px;*/
        line-height: 20px;
    }
    .msg__ {
        line-height: 40px;
        padding: 0 40px;
        font-size: 16px;
        .msg_c {
            font-size: 16px;
        }
    }
</style>